



























































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, ProvideReactive, Vue, Inject, Provide } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import SimPro from '@/components/tables/simPro.vue';
import AddNote from '@/components/add business objects/addNote.vue';
import addOrgToProduct from '@/components/add business objects/addOrgToProduct.vue';
import EditChargesModal from '@/pages/account/organisations/billing/EditPlanChargesModal.vue';
import {
	BillingApi,
	Entities,
	EntityLocation,
	EntityStatus,
	Fault,
	Org,
	OrgsApi,
	Product,
	ProductType,
	ProductsApi,
	SimproJobDetails,
	Site,
	Tank,
	Transceiver,
	WaterMeter,
	WaterMetersApi,
	WaterMonitor,
	WaterMonitorInfo,
	WaterMonitorsApi,
	WaterTank,
	WaterTanksApi,
} from '@/api';
import Toast from '@/components/display/toast.vue';
import DataTable from '@/components/datatable.vue';
import { email, minLength, numeric, required } from 'vuelidate/lib/validators';
import WaterTankForm from '@/components/form pickers/waterTankForm.vue';
import WaterMonitorForm from '@/components/form pickers/waterMonitorForm.vue';
import WaterMeterForm from '@/components/form pickers/waterMeterForm.vue';
import { validationMixin } from 'vuelidate';
import UsersTable from '@/components/tables/users-table.vue';
import FlowContainer from '@/components/flow/flow-container/flow-container';
import WaterEntityChartAdmin from '@/components/charts/water-entity-chart.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import AddJob from '@/components/add business objects/addJob.vue';
import rebootTransceiver from '@/components/elements/functional buttons/reboot-transceiver.vue';
import addFault from '@/components/add business objects/addFault.vue';
import {
	formatProductTier,
	formatProductTierAttribute,
	getProductBillingAttributes,
	ProductOrdwayAttributes,
} from '@/models/ordway';
import { AxiosError, AxiosResponse } from 'axios';
import { OrdwayService } from '@/services/ordway-service';
import ChangeProductOrgModal from '../ChangeProductOrgModal.vue';
import WaterLinks from '@/components/display/waterLinks.vue';
import WaterConsents from '@/components/display/water-consent-profile-view.vue';
import ExternalLinkButton from '@/components/elements/buttons/external-link-button.vue';
import WaterEntityView from '@/pages/account/products/water/entity/view.vue';
import EntityForm from '@/components/form pickers/entityForm.vue';
import ConfirmModal from '@/components/display/confirm-modal.vue';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';
import BillingSetupForm from '@/components/billing-setup-form/billing-setup-form.vue';
import ProductTrialModal from '@/components/ProductTrialModal.vue';
import ProductCountryFlagRow from '@/components/display/product-country-flag-row.vue';
import AddUserForm from '@/components/add business objects/add-user/AddUserForm.vue';
import { getProductAllowedUserCount, getProductAllowedUserIds } from '@/services/user-service';
import RepairJobTexts from '@/components/tables/repair-job-texts.vue';
import { Constants } from '@/common/Constants';
import { ProductStatusService } from '@/services/product-status-service';
import AddJobModalsContainer from '@/components/add business objects/add-job/AddJobModalsContainer.vue';
import EntityMap from '@/components/display/maps/entityMap.vue';
import { LastCheckInService } from '@/services/last-check-in-service';
import { ParsingUtil } from '@/common/ParsingUtil';
import InformationRow from '@/components/display/information-row.vue';
import FaultStatusRow from '@/components/display/information-rows/fault-status-row.vue';
import SiteRow from '@/components/display/information-rows/site-row.vue';
import OrgRow from '@/components/display/information-rows/org-row.vue';
import NotesRow from '@/components/display/information-rows/notes-row.vue';
import PlanRow from '@/components/display/information-rows/plan-row.vue';
import TrialRow from '@/components/display/information-rows/trial-row.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import LastCheckInTag from '@/components/display/information-rows/last-check-in-tag.vue';
import ProductActionsBar from '@/components/ProductActionsBar.vue';
import { FeedProductModals } from '@/pages/account/products/feed/models';
import TitleMixin from '@/mixins/title-mixin';
import WaterConsentOverview from '@/components/display/water-consents/water-consent-overview.vue';
import WarningIcon from '@/components/display/warning-icon.vue';
import SmsCharges from '@/components/smsCharges/smsCharges.vue';
import { formattedStatus } from '@/common/StatusUtil';
import { WaterEntityUtil } from '@/common/WaterEntityUtil';
import { BillingService } from '@/services/billing-service';
import { OrgService } from '@/services/org-service';

@Component({
	computed: {
		EntityStatus() {
			return EntityStatus;
		},
	},
	components: {
		WarningIcon,
		WaterConsentOverview,
		ProductActionsBar,
		LastCheckInTag,
		ChangelogLink,
		TrialRow,
		PlanRow,
		NotesRow,
		OrgRow,
		SiteRow,
		FaultStatusRow,
		InformationRow,
		AddJobModalsContainer,
		EntityForm,
		FlowContainer,
		SimPro,
		UsersTable,
		AddJob,
		AddNote,
		secondaryNav,
		DataTable,
		Toast,
		WaterEntityChartAdmin,
		infoTabs,
		rebootTransceiver,
		addFault,
		EditChargesModal,
		ChangeProductOrgModal,
		WaterLinks,
		WaterConsents,
		WaterTankForm,
		WaterMonitorForm,
		WaterMeterForm,
		ExternalLinkButton,
		addOrgToProduct,
		WaterEntityView,
		ConfirmModal,
		BillingSetupButton,
		BillingSetupForm,
		ProductTrialModal,
		ProductCountryFlagRow,
		AddUserForm,
		RepairJobTexts,
		EntityMap,
		SmsCharges,
	},
	methods: {
		formatProductTier,
	},
	validations: {
		userForm: {
			name: { required },
			email: { email, required },
			phone: { numeric, minLength: minLength(6), required },
			permission: {},
		},
	},
	mixins: [validationMixin, TitleMixin],
})
export default class ProductView extends Vue {
	get productPlan(): string {
		if (this.productOrdwayAttributes !== null) {
			return this.productOrdwayAttributes.ordwayPlanName;
		}
		return '';
	}

	get partnerPlan(): string {
		if (this.partnerProductOrdwayAttributes !== null) {
			return this.partnerProductOrdwayAttributes.ordwayPlanName;
		}
		return '';
	}

	get productTier(): string {
		return formatProductTierAttribute(this.productOrdwayAttributes);
	}

	public get formattedProductStatus(): string {
		return formattedStatus(
			this.product,
			ProductStatusService.formatProductStatus(
				this.product?.status ?? null,
				this.product?.termsState ?? null,
			),
			'product',
		);
	}

	get billingAttributes() {
		return getProductBillingAttributes(
			this.productOrdwayAttributes,
			this.partnerProductOrdwayAttributes,
			this.product.subscriptionitem,
		);
	}

	public get transceivers(): (WaterMeter | WaterTank | WaterMonitor)[] {
		return [...this.water_meters, ...this.water_tanks, ...this.water_monitors].filter(
			waterEntity => waterEntity.transceiver,
		);
	}

	public get waterEntityLocations(): { entityType: string; location: EntityLocation }[] {
		return [
			...this.getEntityLocations(this.water_meters, Constants.ENTITY_TYPE_WATER_METER),
			...this.getEntityLocations(this.water_tanks, Constants.ENTITY_TYPE_WATER_TANK),
			...this.getEntityLocations(this.water_monitors, Constants.ENTITY_TYPE_WATER_MONITOR),
		].flat();
	}

	public get mapCenter(): { lat: number; lng: number } | null {
		if (!this.product?.site || !this.product?.site.latitude || !this.product?.site.longitude) {
			return null;
		}
		return {
			lat: parseFloat(this.product.site.latitude),
			lng: parseFloat(this.product.site.longitude),
		};
	}

	public get partnerContribution(): string {
		return `${
			this.currentBilling && this.currentBilling.partnerContributionTier
				? [
						this.$options.filters?.capitalise(
							this.$options.filters?.decamelize(this.currentBilling.partnerContributionTier),
						),
						this.currentBilling.partnerName,
						WaterEntityUtil.getEntityTypeDisplayName(this.currentBilling.partnerEntityAccess),
				  ]
						.filter(item => item)
						.join(' | ')
				: 'No Contribution'
		}`;
	}
	public smallScreen = window.innerWidth > 1000;

	public loading: boolean = true;
	public fetchingOrdwayAttributes: boolean = true;

	@ProvideReactive('waterProduct')
	public product: (Product & { org: Org; site: Site; productstatuschanges: any[] }) | null = null;

	private currentBilling: any | null = null;
	public org: any | null = null;
	private toast: Toast = new Toast();
	public users: any[] = [];
	public allowedUserIds: number[] | null = null;
	private water_metersCurrentPage = 1;
	private water_monitorsCurrentPage = 1;
	private water_tanksCurrentPage = 1;
	private readonly perPage = 1;
	public productOrdwayAttributes: ProductOrdwayAttributes | null = null;
	private partnerProductOrdwayAttributes: ProductOrdwayAttributes | null = null;
	public siteError: string | null = null;
	public expandError: boolean = false;
	public partnerFields: any[] | null = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{
			key: 'contributionTier',
			label: 'Contribution Tier',
			formatter: (val: string) => Vue.filter('titleCase')(val),
		},
	];
	public renderKey = 0;
	public audits: any[] = [];
	public syncing: boolean = false;
	public simproJobs: SimproJobDetails[] = [];

	public pageTitle() {
		return `Water | ${this.product ? this.product.name : ''}`;
	}

	public changelogFields: any[] | null = [
		{ key: 'created_at', label: 'Created At' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'User Name' },
	];

	public waterMeterFields: any[] = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{ key: 'entitylocation.latitude', label: 'Latitude' },
		{ key: 'entitylocation.longitude', label: 'Longitude' },
		{ key: 'status', label: 'Status' },
		{ key: 'transceiver.serialNumber', label: 'Transceiver' },
		{ key: 'sensor.serialNumber', label: 'Sensor' },
		{ key: 'sensor.lastCheckIn', label: 'Last Checked In' },
	];

	public waterTankFields: any[] = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{ key: 'entitylocation.latitude', label: 'Latitude' },
		{ key: 'entitylocation.longitude', label: 'Longitude' },
		{ key: 'status', label: 'Status' },
		{ key: 'transceiver.serialNumber', label: 'Transceiver' },
		{ key: 'sensor.serialNumber', label: 'Sensor' },
		{ key: 'sensor.lastCheckIn', label: 'Last Checked In' },
	];

	public waterMonitorFields: any[] = [
		{ key: 'main', label: 'Main', tdClass: 'p-0 h-1px' },
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{ key: 'entitylocation.latitude', label: 'Latitude' },
		{ key: 'entitylocation.longitude', label: 'Longitude' },
		{ key: 'status', label: 'Status' },
		{ key: 'transceiver.serialNumber', label: 'Transceiver' },
		{ key: 'sensor.serialNumber', label: 'Sensor' },
		{ key: 'sensor.lastCheckIn', label: 'Last Checked In' },
	];

	public water_meters: (WaterMeter & {
		transceiver: Transceiver | null;
		entitylocation: EntityLocation | null;
	})[] = [];
	public water_tanks: (WaterTank & {
		transceiver: Transceiver | null;
		entitylocation: EntityLocation | null;
	})[] = [];
	public water_monitors: (WaterMonitor & {
		transceiver: Transceiver | null;
		entitylocation: EntityLocation | null;
	})[] = [];
	public settingMainMonitor: WaterMonitorInfo | boolean = false;
	public partnerOrgs: Org[] | undefined = [];
	public jobsExist = false;

	public faults: Fault[] = [];

	public transceiverFields: any[] | null = [
		{ key: 'transceiver.id', label: 'Id', sortable: true },
		{ key: 'name', label: 'Entity', sortable: true },
		{ key: 'transceiver.createdAt', label: 'Created', sortable: true },
		{ key: 'transceiver.serialNumber', label: 'Serial Number', sortable: true },
		{ key: 'transceiver.imei', label: 'IMEI', sortable: true },
		{ key: 'transceiver.firmwareVersion', label: 'Firmware' },
		{ key: 'lastCheckIn', label: 'Last Check In' },
		{ key: 'reboot', label: 'Reboot' },
	];

	public entityTypes: Entities[] = [
		Entities.WaterMeters,
		Entities.WaterTanks,
		Entities.WaterMonitors,
	];

	private api: ProductsApi = new ProductsApi();
	private waterMonitorsApi: WaterMonitorsApi = new WaterMonitorsApi();
	private waterTanksApi: WaterTanksApi = new WaterTanksApi();
	private waterMetersApi: WaterMetersApi = new WaterMetersApi();
	private productStatusService: ProductStatusService<
		WaterMeter | WaterTank | WaterMonitor
	> = new ProductStatusService<WaterMeter | WaterTank | WaterMonitor>(this.product);

	public canAddUser: boolean = false;

	private productId?: number | null;

	public get canCreateInstallJobs(): boolean {
		if (!this.product) {
			return false;
		}
		const pendingEntities =
			this.water_meters.map(meter => meter.status).includes('pending') ||
			this.water_tanks.map(tank => tank.status).includes('pending') ||
			this.water_monitors.map(monitor => monitor.status).includes('pending');
		return pendingEntities;
	}

	public async reRender() {
		this.renderKey > 0 ? this.renderKey-- : this.renderKey++;
	}
	public rowClickHandler(item, index) {
		this[`water_${item.type}sCurrentPage`] = index + 2;
	}
	public newFault(e: Event) {
		this.product.faults.push(e);
	}
	public getPaginationListItem(page, entitys) {
		return [{ name: 'Overview' }].concat(entitys)[page - 1];
	}

	public async updateCurrentPage(event, type: string) {
		this[`${type}CurrentPage`] =
			[{ name: 'Overview', id: 0 }]
				.concat(this[type])
				.map(entity => parseInt(entity.id, 10))
				.indexOf(parseInt(event, 10)) + 1;
	}

	public async created() {
		this.productId = ParsingUtil.parseId(this.$route.params.productId);
		await this.onCreated();

		this.$watch(
			() => this.$route.params.productId,
			async (to, from) => {
				this.productId = ParsingUtil.parseId(to) ?? this.productId;
				await this.onCreated();
			},
		);
		await this.loadBilling();
	}

	public async loadBilling() {
		const billingService = new BillingService();
		const orgService = new OrgService();

		const currentBillingResponse = await billingService.getCurrentBilling(this.productId!);
		const currentBilling = currentBillingResponse?.billing;

		if (currentBilling && currentBilling?.partnerId !== null) {
			const billingPartnersResponse = await orgService.orgGetBillingPartnersByProductType(
				ProductType.Water,
			);
			const billingPartners = billingPartnersResponse?.orgs;

			if (billingPartners) {
				const partner = billingPartners.find(partner => partner.id == currentBilling.partnerId);
				if (partner) {
					this.currentBilling = { ...currentBilling, partnerName: partner.name };
				}
			} else if (!billingPartners && billingPartnersResponse.errorMessage) {
				this.toast.makeToast(
					billingPartnersResponse.errorMessage,
					`Error fetching billing partners for: '${ProductType.Water}'`,
					'danger',
				);
			}
		} else if (!currentBilling && currentBillingResponse.errorMessage) {
			this.toast.makeToast(
				currentBillingResponse.errorMessage,
				`Error fetching current billing for: '${this.productId}'`,
				'danger',
			);
		}
	}

	public async onCreated() {
		if (this.productId == null) {
			this.siteError = `Failed to load product for ID '${this.$route.params.productId}'`;
			this.loading = false;
			return;
		}

		await this.loadProduct();
		await this.loadPartners();
		await this.fetchProductOrdwayAttribute();

		this.productStatusService = new ProductStatusService<WaterMeter | WaterTank | WaterMonitor>(
			this.product,
		);
		setTimeout(() => {
			if (localStorage.getItem('WATER_LINKS_ACKNOWLEDGED') == null) {
				this.$bvModal.show('water-links-modal');
			}
		}, 100);
		if (this.$route.params.showJob) {
			this.$bvModal.show('jobModal');
		}
		if (
			this.productOrdwayAttributes === null &&
			this.product.status !== 'cancelled' &&
			this.product.status !== 'removed'
		) {
			(this.$refs.billingSetupButton as BillingSetupButton).openEditBillingModal();
		}
	}

	public async loadPartners() {
		try {
			const data = await new ProductsApi().getProductPartnerOrgs(this.productId!);
			this.partnerOrgs = data.data.data.filter(p => p !== null);
		} catch (e) {
			this.partnerOrgs = undefined;
			console.log(e);
		}
	}

	public async deleteProduct() {
		if (this.product) {
			await this.makeRequest(
				'Water',
				'Removing',
				'Removed',
				async () => {
					await this.api.deleteProduct(this.product.id);
					this.$router.push({ name: 'products.list' });
				},
				false,
			);
		}
	}

	public toggleErrorExpand() {
		this.expandError = !this.expandError;
	}

	public openProductOrgChangeModal(): void {
		this.$bvModal.show('product-org-change-modal');
	}

	public closeOrgModal(): void {
		this.$bvModal.hide('product-org-change-modal');
	}

	public async resetProductOrg() {
		await this.loadProduct();
	}

	public setJobsToTrue() {
		this.jobsExist = true;
	}

	public simproJobsLoaded(simproJobs: SimproJobDetails[]) {
		this.simproJobs = simproJobs;
	}

	public async onOrgChanged() {
		await this.loadProduct();
		this.closeOrgModal();
		new Toast().makeToast('Org changed successfully', 'Success', 'success', false);
	}

	public async loadUsers() {
		const product = await this.loadProduct();
		this.users = product.users;
		this.users.forEach(user => {
			this.form.users.push(Object.assign({ checked: false, sms: false, id: user.id }, user));
		});
	}

	public confirmMainMonitor(event: any, monitor: WaterMonitorInfo) {
		this.$bvModal
			.msgBoxConfirm(
				`Please confirm that you want to set "${monitor.name}" as the main water usage.`,
				{
					title: 'Main Monitor Confirm',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'primary',
					okTitle: 'Submit',
					cancelTitle: 'Cancel',
					footerClass: 'p-2',
					headerBgVariant: 'primary',
					headerTextVariant: 'white',
					hideHeaderClose: false,
					centered: true,
				},
			)
			.then(value => {
				if (value) {
					this.setMainWaterMonitor(event, monitor);
				}
			})
			.catch(err => {
				console.log(err);
			});
	}

	public async setMainWaterMonitor(event, monitor: WaterMonitorInfo) {
		if (!this.settingMainMonitor) {
			this.settingMainMonitor = monitor;
			if (!monitor.main) {
				try {
					await this.waterMonitorsApi.setMainWaterMonitor(monitor.id, {
						data: monitor,
					});
					this.monitors.forEach(m => (m.main = false));
					monitor.main = true;
				} catch (e) {
					new Toast().makeToast(
						`Failed to set ${monitor.name} as the main farm monitor: ${e.request != null &&
							e.request.status === 404}`,
						'Error',
						'danger',
					);
				}
			} else {
				try {
					monitor.main = false;
					await this.waterMonitorsApi.updateWaterMonitor(monitor.id, {
						data: monitor,
					});
					monitor.main = false;
				} catch (e) {
					new Toast().makeToast(
						`Failed to unset ${monitor.name} from being the main farm monitor: ${
							e.request != null && e.request.status === 404 ? 'Product Does Not Exist' : e
						}`,
						'Error',
						'danger',
					);
				}
			}
			this.settingMainMonitor = false;
		}
	}

	public async reload() {
		await this.loadProduct();
	}

	public async loadProduct() {
		if (this.productId == null) {
			this.loading = false;
			return;
		}
		try {
			const { data } = await this.api.getProductById(this.productId, {
				params: {
					include:
						'org,audits,audits.user,tanks,site,site.address,faults,faults.owner,subscriptionitem,users,' +
						'watermeters,watertanks,watermonitors,' +
						'watermeters.transceiver,watermeters.sensor,' +
						'watertanks.transceiver,watertanks.sensor,' +
						'watermonitors.transceiver,watermonitors.sensor,' +
						'users,productstatuschanges,' +
						'watermeters.watermeterins,watermeters.watertankins,watermeters.watermonitorins,' +
						'watertanks.watermeterins,watertanks.watertankins,watertanks.watermonitorins,' +
						'watermonitors.watermeterins,watermonitors.watertankins,watermonitors.watermonitorins,' +
						'watermeters.watermeterouts,watermeters.watertankouts,watermeters.watermonitorouts,' +
						'watertanks.watermeterouts,watertanks.watertankouts,watertanks.watermonitorouts,' +
						'watermonitors.watermeterouts,watermonitors.watertankouts,watermonitors.watermonitorouts,' +
						'watermeters.entitylocation,watertanks.entitylocation,watermonitors.entitylocation',
				},
			});
			this.product = data;
			this.org = data.org || {};

			this.faults = data.faults || [];
			this.audits = data.audits || [];

			this.water_meters = (data.watermeters || [])
				.map((meter: any) => {
					return {
						...meter,
						transceiver: meter.transceiver ? meter.transceiver : null,
						sensor: meter.sensor ? meter.sensor : null,
						type: 'meter',
					};
				})
				.sort(
					(a, b) =>
						(this.getStatusPriority(a.status) >= this.getStatusPriority(b.status) && 1) || -1,
				);

			this.water_tanks = (data.watertanks || [])
				.map((tank: any) => {
					return {
						...tank,
						transceiver: tank.transceiver ? tank.transceiver : null,
						sensor: tank.sensor ? tank.sensor : null,
						type: 'tank',
					};
				})
				.sort(
					(a, b) =>
						(this.getStatusPriority(a.status) >= this.getStatusPriority(b.status) && 1) || -1,
				);

			this.water_monitors = (data.watermonitors || [])
				.map((monitor: any) => {
					return {
						...monitor,
						transceiver: monitor.transceiver ? monitor.transceiver : null,
						sensor: monitor.sensor ? monitor.sensor : null,
						type: 'monitor',
					};
				})
				.sort(
					(a, b) =>
						(this.getStatusPriority(a.status) >= this.getStatusPriority(b.status) && 1) || -1,
				);

			for (const entity of [
				...this.water_meters,
				...this.water_tanks,
				...this.water_monitors,
			] as any[]) {
				if (entity.sensor) {
					LastCheckInService.getLastCheckIn('sensor', entity.sensor.id).then(
						(lastCheckInResponse: { lastCheckInTimestamp?: number; errorMessage?: string }) => {
							if (!lastCheckInResponse.errorMessage) {
								entity.sensor.lastCheckIn = lastCheckInResponse.lastCheckInTimestamp;
							}
						},
					);
				}
			}

			this.users = data.users || [];
			this.allowedUserIds = await getProductAllowedUserIds(this.productId!);
			const allowedUserCount = await getProductAllowedUserCount(this.productId!);
			this.canAddUser =
				allowedUserCount == null ||
				(this.product?.users && this.product?.users?.length < allowedUserCount);
		} catch (e) {
			new Toast().makeToast(
				`Failed to load product: ${e.request.status === 404 ? 'Product Does Not Exist' : e}`,
				'Error',
				'danger',
			);
			this.product = null;
			this.siteError = e;
			if (e.response && e.response.data && e.response.data.message) {
				this.siteError = e.response.data.message;
			}
		} finally {
			this.loading = false;
			this.reRender();
			if (this.$route.params.entityId && this.$route.params.entityType) {
				console.log(this.$route.params.entityType);
				await this.updateCurrentPage(this.$route.params.entityId, this.$route.params.entityType);
			}
		}
	}

	private getStatusPriority(status: string): number {
		switch (status) {
			case 'live':
				return 1;
			case 'pending':
				return 2;
			case 'install':
				return 3;
			case 'sign-off':
				return 4;
			case 'removed':
				return 5;
			case 'cancelled':
				return 6;
			default:
				return 0;
		}
	}

	private async fetchProductOrdwayAttribute(): Promise<void> {
		try {
			const productOrdwayAttributeResponse: AxiosResponse<ProductOrdwayAttributes> = await OrdwayService.fetchProductOrdwayAttributes(
				this.product.id,
				this.product.orgId,
			);
			this.productOrdwayAttributes = productOrdwayAttributeResponse.data;
		} catch (errorResponse) {
			const error: AxiosError = errorResponse as AxiosError;
			if (error.response) {
				const errorMessage = error.response.data.errors;
				new Toast().makeToast(errorMessage, 'No plan found for this product', 'danger', true);
			} else {
				new Toast().makeToast(
					'There was a problem loading the Ordway attributes for this product, please let the software team know',
					'Error loading Ordway attributes',
					'danger',
					true,
				);
			}
		} finally {
			this.fetchingOrdwayAttributes = false;
		}
	}

	private async makeRequest(
		type: string,
		actioning: string,
		actioned: string,
		runnable: () => void,
		reload: boolean = true,
	) {
		try {
			await runnable();
		} catch (ex) {
			let error;

			if (ex.response && ex.response.data) {
				error = ex.response.data.message;
			} else if (ex.request) {
				error = 'Network Error';
			} else {
				error = 'Unknown Error';
			}

			new Toast().makeToast(
				`${type} not ${actioned}: ${error}`,
				`Error ${actioning} ${type}`,
				'danger',
				true,
			);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast(`${type} ${actioned}`, 'Success', 'success');
		if (reload) {
			setTimeout(() => this.loadProduct(), 1000);
		}
	}

	public async syncOrdwayDraftSubscription() {
		this.syncing = true;
		await OrdwayService.syncOrdwayDraftSubscription(this.product.id);
		this.loadProduct();
		this.syncing = false;
		new Toast().makeToast('Ordway Draft Subscription synchronised', 'Successful', 'success');
	}

	private getEntityLocations(
		entities: { entitylocation: EntityLocation | null }[],
		entityType: string,
	) {
		return entities
			.filter(entity => entity.entitylocation !== null)
			.map(entity => ({ entityType, location: entity.entitylocation!, entity }));
	}
}
